import React from 'react'

const SectionHeader = (props) => (
    <div>
        <div className="header">
            <span className="header-text">
                <span className="header-title">{props.header}</span>
                <span className="header-subtitle"> {props.subHeader} </span>
            </span>
        </div>
        <div className="line" />
    </div>
)

export default SectionHeader
